import React from 'react';
import { Sparkles, X } from 'lucide-react';
import { adminApi } from '../../../lib/adminAuth';
import CategoryReviewDialog from './CategoryReviewDialog';

// Banner on the Invoices tab; re-checks whenever the invoice list changes.
export default function CategoryReviewBanner({ refreshKey, onApplied }) {
  const [data, setData] = React.useState(null);
  const [open, setOpen] = React.useState(false);
  const [hidden, setHidden] = React.useState(false);

  const load = React.useCallback(() => {
    adminApi.get('/api/admin/accounting/invoice-category-review').then((r) => setData(r.data)).catch(() => {});
  }, []);
  React.useEffect(() => { load(); }, [load, refreshKey]);

  const toRet = data?.counts?.retainer || 0;
  const toNon = data?.counts?.non_retainer || 0;
  if (hidden || (!toRet && !toNon)) return null;

  return (
    <>
      <div className="flex flex-wrap items-center gap-3 p-3 sm:p-4 rounded-2xl border border-fuchsia-200 bg-gradient-to-r from-fuchsia-50 to-white animate-in fade-in" data-testid="category-review-banner">
        <div className="w-9 h-9 rounded-xl bg-fuchsia-600 flex items-center justify-center shrink-0"><Sparkles className="w-4 h-4 text-white" /></div>
        <div className="flex-1 min-w-0">
          <p className="text-sm font-semibold text-[#1a1a2e]" data-testid="category-review-banner-text">
            {toRet > 0 && `${toRet} invoice${toRet > 1 ? 's' : ''} look like retainers`}
            {toRet > 0 && toNon > 0 && ' · '}
            {toNon > 0 && `${toNon} retainer invoice${toNon > 1 ? 's' : ''} may not be retainers`}
          </p>
          <p className="text-xs text-slate-500">Found from descriptions, recurring billing and client retainer amounts. Nothing changes until you confirm.</p>
        </div>
        <button type="button" onClick={() => setOpen(true)} className="h-9 px-4 rounded-full bg-[#1a1a2e] hover:bg-fuchsia-700 text-white text-sm font-semibold transition-colors active:scale-95" data-testid="category-review-open">Review</button>
        <button type="button" onClick={() => setHidden(true)} className="p-1.5 rounded-lg hover:bg-white" title="Hide for now" data-testid="category-review-banner-hide"><X className="w-4 h-4 text-slate-500" /></button>
      </div>
      <CategoryReviewDialog open={open} data={data} onClose={() => setOpen(false)}
        onDone={() => { load(); onApplied?.(); }} />
    </>
  );
}
